import {
  $applyNodeReplacement,
  ElementNode,
  LexicalNode,
  LexicalUpdateJSON,
  SerializedElementNode,
} from 'lexical';

export type SerializedNoWrapNode = SerializedElementNode;

export class NoWrapNode extends ElementNode {
  static getType(): string {
    return 'nowrap';
  }

  static clone(node: NoWrapNode): NoWrapNode {
    return new NoWrapNode(node.__key);
  }

  static importJSON(serializedNode: SerializedNoWrapNode): NoWrapNode {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define, no-use-before-define
    return $createNoWrapNode().updateFromJSON(serializedNode);
  }

  updateFromJSON(serializedNode: LexicalUpdateJSON<SerializedNoWrapNode>): this {
    return super.updateFromJSON(serializedNode);
  }

  exportJSON(): SerializedNoWrapNode {
    return {
      ...super.exportJSON(),
    };
  }

  createDOM(): HTMLElement {
    const element = document.createElement('span');
    element.style.whiteSpace = 'nowrap';

    return element;
  }

  updateDOM(): boolean {
    return false;
  }

  isInline(): boolean {
    return true;
  }

  excludeFromCopy(destination): boolean {
    return destination !== 'clone';
  }
}

export function $createNoWrapNode(): NoWrapNode {
  return $applyNodeReplacement(new NoWrapNode());
}

export function $isNoWrapNode(node: LexicalNode | null): node is NoWrapNode {
  return node instanceof NoWrapNode;
}
